import {GET_scruFillValType} from '../constants/ActionTypes'

const INIT_STATE = {
    ScruValuationType: null,
    //Message1: ''
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        
        case GET_scruFillValType:
                return {
                    ScruValuationType: action.body,
                    //Message1:action.msg
                    
                }
        default:
            return state;
            
    }
}